export enum AppRole {
  ADMIN = 'admin',
  SUPERADMIN = 'superadmin',
  DOCTOR = 'doctor',
  COLLABORATOR = 'collaborator'
}

export const ALL_ROLES: AppRole[] = [
  AppRole.ADMIN,
  AppRole.SUPERADMIN,
  AppRole.DOCTOR,
  AppRole.COLLABORATOR
];

/**
 * Mapping route segment → ruoli che possono accedere.
 * È la source of truth unica: usata sia dal RoleGuard (protezione rotte)
 * che dal NavService (costruzione dinamica del menu).
 */
export const ROUTE_ROLES: Record<string, AppRole[]> = {
  '': ALL_ROLES,
  profilo: ALL_ROLES,
  pazienti: ALL_ROLES,
  operatorie: ALL_ROLES,
  medici: [AppRole.ADMIN, AppRole.SUPERADMIN],
  'utenti-app': [AppRole.ADMIN, AppRole.SUPERADMIN],
  configurazioni: [AppRole.ADMIN, AppRole.SUPERADMIN],
  calendario: ALL_ROLES,
  'chat-pazienti': [AppRole.ADMIN, AppRole.SUPERADMIN, AppRole.DOCTOR]
  // comunicazioni: [AppRole.ADMIN, AppRole.SUPERADMIN]
};

export function normalizeRole(role: string | null | undefined): AppRole | null {
  if (!role) return null;
  const lower = role.toLowerCase();
  return Object.values(AppRole).includes(lower as AppRole) ? (lower as AppRole) : null;
}

export function hasAccess(role: string | null | undefined, routeSegment: string): boolean {
  const normalized = normalizeRole(role);
  if (!normalized) return false;
  const allowed = ROUTE_ROLES[routeSegment];
  if (!allowed) return false;
  return allowed.includes(normalized);
}
